import { useKeywordCompetitorsPageContext } from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsPageContext";
import { SearchInput } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";

const i18n = i18nFilter();

export const SearchFilter = () => {
    const { search, onSearch } = useKeywordCompetitorsPageContext();
    return (
        <SearchInput
            disableClear={true}
            defaultValue={search}
            debounce={400}
            onChange={onSearch}
            placeholder={i18n("forms.search.placeholder")}
        />
    );
};
